export const WEEKDAY_OPTIONS = [
  { weekday: 0, label: 'Lunes' },
  { weekday: 1, label: 'Martes' },
  { weekday: 2, label: 'Miércoles' },
  { weekday: 3, label: 'Jueves' },
  { weekday: 4, label: 'Viernes' },
  { weekday: 5, label: 'Sábado' },
  { weekday: 6, label: 'Domingo' },
];

// cycle_week: 0 = todas las semanas; 1 = solo semanas ISO impares; 2 = solo
// semanas ISO pares. Permite patrones alternados (ej. domingo libre siempre +
// sábado libre solo semanas pares) con más de una fila por día de semana.
export const CYCLE_WEEK_ALL = 0;
export const CYCLE_WEEK_ODD = 1;
export const CYCLE_WEEK_EVEN = 2;
const VALID_CYCLE_WEEKS = [CYCLE_WEEK_ALL, CYCLE_WEEK_ODD, CYCLE_WEEK_EVEN];

// Un día sin ninguna fila = sigue la rotación automática de turno (no hace
// falta un valor "vacío" explícito).
export const createEmptyWeeklySchedule = () => [];

const toRowShape = (row) => {
  const cycleWeekRaw = Number(row?.cycle_week);
  return {
    weekday: Number(row?.weekday),
    cycle_week: VALID_CYCLE_WEEKS.includes(cycleWeekRaw) ? cycleWeekRaw : CYCLE_WEEK_ALL,
    workshift_id:
      row?.workshift_id === null || row?.workshift_id === undefined
        ? ''
        : String(row.workshift_id),
    is_free_day: Boolean(row?.is_free_day),
  };
};

export const normalizeWeeklySchedule = (rows) => {
  const byKey = new Map();
  (rows || []).forEach((raw) => {
    const row = toRowShape(raw);
    if (Number.isNaN(row.weekday) || row.weekday < 0 || row.weekday > 6) return;
    byKey.set(`${row.weekday}-${row.cycle_week}`, row);
  });

  return Array.from(byKey.values()).sort(
    (a, b) => a.weekday - b.weekday || a.cycle_week - b.cycle_week
  );
};

const isRowFilled = (row) => row.is_free_day || String(row.workshift_id || '').trim() !== '';

export const serializeWeeklySchedule = (rows) =>
  normalizeWeeklySchedule(rows)
    .filter(isRowFilled)
    .map((row) => ({
      weekday: row.weekday,
      cycle_week: row.cycle_week,
      workshift_id: row.is_free_day ? null : Number(row.workshift_id),
      is_free_day: row.is_free_day,
    }));

// Completo = no hay ningún día a medio configurar (elegiste el alcance
// semanal pero todavía no el turno/libre). No exige los 7 días: un horario
// con 0 filas es simplemente "sin días fijos" (se valida aparte si hace
// falta al menos uno, ver isWeeklyScheduleEmpty).
export const isWeeklyScheduleComplete = (rows) =>
  normalizeWeeklySchedule(rows).every(isRowFilled);

export const isWeeklyScheduleEmpty = (rows) => normalizeWeeklySchedule(rows).length === 0;
